import React, { useEffect, useState } from "react";
import DatePicker from "react-date-picker";
import { SearchIcon, QuestionMarkCircleIcon } from "@heroicons/react/solid";
import {
  DocumentDownloadIcon,
  MailOpenIcon,
} from "@heroicons/react/outline";
import Layout from "../../components/Layout/Layout";

import CustomerServices from "../../services/CustomerServices";
import { convert, pascalCASE } from "../../utils/convertDate";
import Paginate from "../../utils/Paginate";
import ActionDropdown from "../../components/ActionDropdown";
import fire from "./../../utils/Toastr";
import { formatDate, formatDateForDisplay, DisplayTime } from "./../../utils/convertDate";

import { IsNullOrEmpty } from "../../utils/checkForNull";
import ClearCacheModal from "../../components/Modals/Customer/Modal";

const statusStyles = {
  Active: "bg-green-500 text-white",
  Disabled: "bg-amber-400 text-white",
  Inactive: "bg-orange-600 text-white",
  true: "bg-orange-600 text-white",
  false: "bg-green-500 text-white",
};

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function CustomerList() {
  const [customer, setCustomer] = useState([]);
  const [loading, setLoading] = useState({
    loading: false,
  });
  const [panicLoader, setPanicLoader] = useState({ panic: false });
  const [sleepLoader, setSleepLoader] = useState({ sleep: false });
  const [maskLoader, setMaskLoader] = useState({ mask: false });
  const [resetLoader, setResetLoader] = useState({ reset: false });
  const [search, setSearch] = useState("");
  const [pageIndex, setPageIndex] = useState(1);
  const [prevPage, setPrev] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPage, setPage] = useState(0);
  const [nextPage, setNextPage] = useState(false);
  const [from, newChange] = useState("");
  const [to, setToDate] = useState("");
  const [stage, setStage] = useState("");
  const defaultTo = formatDate(new Date());
  const longNew = formatDate(defaultTo);
  const [too, setToo] = useState(convert(longNew));
  const defaultFrom = formatDate(new Date().setDate(new Date().getDate() - 7));
  const longDate = formatDate(defaultFrom);
  const [securityFeature, setSecurityFeature] = useState("");
  const [fromm, setFromm] = useState(convert(longDate));
  const [pageLength, setPageLength] = useState("");
  const [summ, setSummary] = useState({});
  const oldFrom = new Date().setDate(new Date().getDate() - 7);
  const [formValues, setFormValues] = useState({
    from: new Date(oldFrom),
    to: new Date(),
  });
  const [adminType, setAdminType] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [selectedUserName, setSelectedUserName] = useState("");

  const listCustomer = async () => {
    var details = sessionStorage.getItem("user");
    var userDetails = JSON.parse(details);
    var modules = [];
    modules = (userDetails.moduleAssigned || "").split(",");
    var sect = modules.find((x) => x === "security");
    if (sect === "security") {
      setSecurityFeature(sect);
    }
    var type = userDetails.adminType;
    setAdminType(type);
    const customers = await CustomerServices.listCustomers(
      pageIndex,
      10,
      search,
      fromm,
      too,
      stage
    );
    setCustomer([...customers.data.result]);
    setPageLength([...customers.data.result].length);
    setPageNumber(customers.data.totalCount);
    setPageIndex(customers.data.pageIndex);
    setPrev(customers.data.hasPreviousPage);
    setNextPage(customers.data.hasNextPage);
    setPage(customers.data.totalPages);
    const summ = await CustomerServices.getSummary();
    setSummary(summ.data);
  };

  const setSort = async (e) => {
    if (e.target.value === "All" || e.target.value === "sort") {
      const customers = await CustomerServices.listCustomers(
        pageIndex,
        10,
        search,
        fromm,
        too,
        ""
      );
      setCustomer([...customers.data.result]);
      setPageLength([...customers.data.result].length);
      setPageNumber(customers.data.totalCount);
      setPageIndex(customers.data.pageIndex);
      setPrev(customers.data.hasPreviousPage);
      setNextPage(customers.data.hasNextPage);
      setPage(customers.data.totalPages);
    } else {
      setStage(e.target.value);
      const customers = await CustomerServices.listCustomers(
        pageIndex,
        10,
        search,
        fromm,
        too,
        e.target.value
      );
      setCustomer([...customers.data.result]);
      setPageLength([...customers.data.result].length);
      setPageNumber(customers.data.totalCount);
      setPageIndex(customers.data.pageIndex);
      setPrev(customers.data.hasPreviousPage);
      setNextPage(customers.data.hasNextPage);
      setPage(customers.data.totalPages);
    }
  };
  const searchCustomer = async (text) => {
    setSearch(text);
  };
  const resendMail = async (username) => {
    setLoading({
      loading: true,
    });
    const resp = await CustomerServices.verficationMail({ userName: username });
    if (resp) {
      fire("success", resp.message);
    }
    setLoading({ loading: false });
  };
  const exportCSV = async () => {
    const resp = await CustomerServices.exportList(search, fromm, too, stage);
    window.open(resp.data);
  };

  const dateValidation = {
    fromHandler: (event) => {
      setFormValues({ ...formValues, from: event });
    },
    toHandler: (event) => {
      setFormValues({ ...formValues, to: event });
    },
  };

  const range = async (e) => {
    e.preventDefault();
    const newDate = formatDate(formValues.from);
    newChange(formValues.from);
    var longDate = formatDate(newDate);
    setFromm(convert(longDate));

    const toDate = formatDate(formValues.to);
    setToDate(formValues.to);
    setToo(convert(toDate));

    const customers = await CustomerServices.listCustomers(
      pageIndex,
      10,
      search,
      convert(newDate),
      convert(toDate),
      stage
    );
    setCustomer([...customers.data.result]);
    setPageLength([...customers.data.result].length);
    setPageNumber(customers.data.totalCount);
    setPageIndex(customers.data.pageIndex);
    setPrev(customers.data.hasPreviousPage);
    setNextPage(customers.data.hasNextPage);
    setPage(customers.data.totalPages);
  };
  const sleepMode = async (person) => {
    setSleepLoader({
      sleep: true,
    });
    if (!IsNullOrEmpty(person.freezeModeApprovalLevel)) {
      if (
        adminType.toLowerCase() === "maker" &&
        person.freezeModeApprovalLevel.toLowerCase() === "initiated"
      ) {
        fire(
          "error",
          "This has already been initiated and awaiting approval of a checker"
        );
        setSleepLoader({ sleep: false });
        return;
      }
      if (
        adminType.toLowerCase() === "checker" &&
        person.freezeModeApprovalLevel.toLowerCase() !== "initiated"
      ) {
        fire("error", "This request has not been initied yet.");
        setSleepLoader({ sleep: false });
        return;
      }
    }
    const resp = await CustomerServices.securityMode({
      modeToUpdate: "freezeMode",
      customerUserName: person.userName,
    });
    if (resp) {
      fire("success", resp.message);
      setTimeout(() => {
        window.location.reload();
      }, 5000);
    }
    setSleepLoader({
      sleep: false,
    });
  };
  const maskMode = async (person) => {
    setMaskLoader({
      mask: true,
    });
    if (!IsNullOrEmpty(person.stealModeApprovalLevel)) {
      if (
        adminType.toLowerCase() === "maker" &&
        person.stealModeApprovalLevel.toLowerCase() === "initiated"
      ) {
        fire(
          "error",
          "This has already been initiated and awaiting approval of a checker"
        );
        setMaskLoader({
          mask: false,
        });
        return;
      }
      if (
        adminType.toLowerCase() === "checker" &&
        person.stealModeApprovalLevel.toLowerCase() !== "initiated"
      ) {
        fire("error", "This request has not been initied yet.");
        setMaskLoader({
          mask: false,
        });
        return;
      }
    }
    const resp = await CustomerServices.securityMode({
      modeToUpdate: "StealthMode",
      customerUserName: person.userName,
    });
    if (resp) {
      fire("success", resp.message);
      setTimeout(() => {
        window.location.reload();
      }, 5000);
    }
    setMaskLoader({
      mask: false,
    });
  };
  const panicMode = async (person) => {
    setPanicLoader({
      panic: true,
    });
    if (!IsNullOrEmpty(person.panicModeApprovalLevel)) {
      if (
        adminType.toLowerCase() === "maker" &&
        person.panicModeApprovalLevel.toLowerCase() === "initiated"
      ) {
        fire(
          "error",
          "This has already been initiated and awaiting approval of a checker"
        );
        setPanicLoader({
          panic: false,
        });
        return;
      }
      if (
        adminType.toLowerCase() === "checker" &&
        person.panicModeApprovalLevel.toLowerCase() !== "initiated"
      ) {
        fire("error", "This request has not been initied yet.");
        setPanicLoader({
          panic: false,
        });
        return;
      }
    }
    const resp = await CustomerServices.securityMode({
      modeToUpdate: "panicMode",
      customerUserName: person.userName,
    });
    if (resp) {
      fire("success", resp.message);
      setTimeout(() => {
        window.location.reload();
      }, 5000);
    }
    setPanicLoader({
      panic: false,
    });
  };
  const resetUser = async (person) => {
    setResetLoader({ reset: true });
    if (!IsNullOrEmpty(person.pinResetApprovalStatus)) {
      if (
        adminType.toLowerCase() === "maker" &&
        person.pinResetApprovalStatus.toLowerCase() === "initiated"
      ) {
        fire(
          "error",
          "This has already been initiated and awaiting approval of a checker"
        );
        setResetLoader({ reset: true });
        return;
      }
      if (
        adminType.toLowerCase() === "checker" &&
        person.pinResetApprovalStatus.toLowerCase() !== "initiated"
      ) {
        fire("error", "This request has not been initied yet.");
        setResetLoader({ reset: true });
        return;
      }
    }
    const resp = await CustomerServices.resetProfile({
      userName: person.userName,
    });
    if (resp) {
      fire("success", resp.message);
      setTimeout(() => {
        window.location.reload();
      }, 4000);
    }
    setResetLoader({
      reset: false,
    });
  };

  const openClearCacheModal = (userName) => {
    setSelectedUserName(userName);
    setOpenModal(true);
  };

  const clearCache = async () => {
    var payload = {
      username: selectedUserName,
    };
    try {
      const response = await CustomerServices.clearCustomerCache(payload);
      fire("success", response.message);
    } catch (error) {
      fire("error", error);
    } finally {
      setOpenModal(false);
    }
  };

  useEffect(() => {
    listCustomer();
  }, [pageIndex]);

  return (
    <>
      <Layout
        title="Customer Management"
        pageTag={"customer"}
        current={"/customers"}
        curentPage={"list-customer"}
      >
        <React.Fragment>
          <main>
            <div className="max-w-7xl ">
              <dl className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 mb-5">
                <div className="relative flex bg-white pt-5 px-4 pb-5 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden">
                  <div className="absolute  rounded-md p-3">
                    <MailOpenIcon
                      className="h-6 w-6 text-gray-900"
                      aria-hidden="true"
                    />
                  </div>
                  <div>
                    <p className="ml-12 text-sm font-medium text-gray-500 truncate">
                      Total Customers
                    </p>
                    <p className="text-2xl ml-12 font-semibold text-gray-900">
                      {summ.totalOfCustomer}
                    </p>
                  </div>
                </div>
                <div className="relative flex bg-white pt-5 px-4 pb-5 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden">
                  <div className="absolute  rounded-md p-3">
                    <MailOpenIcon
                      className="h-6 w-6 text-gray-900"
                      aria-hidden="true"
                    />
                  </div>
                  <div>
                    <p className="ml-12 text-sm font-medium text-gray-500 truncate">
                      Total Active Customers
                    </p>
                    <p className="text-2xl ml-12 font-semibold text-gray-900">
                      {summ.totalOfActiveCustomer}
                    </p>
                  </div>
                </div>
                <div className="relative flex bg-white pt-5 px-4 pb-5 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden">
                  <div className="absolute  rounded-md p-3">
                    <MailOpenIcon
                      className="h-6 w-6 text-gray-900"
                      aria-hidden="true"
                    />
                  </div>
                  <div>
                    <p className="ml-12 text-sm font-medium text-gray-500 truncate">
                      Total Inactive Customers
                    </p>
                    <p className="text-2xl ml-12 font-semibold text-gray-900">
                      {summ.totalOfInactiveCustomer}
                    </p>
                  </div>
                </div>
                <div className="hidden relative flex bg-white pt-5 px-4 pb-5 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden">
                  <div className="absolute  rounded-md p-3">
                    <MailOpenIcon
                      className="h-6 w-6 text-green-900"
                      aria-hidden="true"
                    />
                  </div>
                  <div>
                    <p className="ml-12 text-sm font-medium text-gray-500 truncate">
                      Active Customers
                    </p>
                    <p className="text-2xl ml-12 font-semibold text-green-900">
                      7
                    </p>
                  </div>
                </div>
                <div className="relative flex bg-white pt-5 px-4 pb-12 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden">
                  <div className="absolute  rounded-md p-3">
                    <MailOpenIcon
                      className="h-6 w-6 text-red-900"
                      aria-hidden="true"
                    />
                  </div>
                  <div>
                    <p className="ml-12 text-sm font-medium text-gray-500 truncate">
                      Total Locked Customers
                    </p>
                    <p className="text-2xl ml-12 font-semibold text-red-900">
                      {summ.totalOfDisabledCustomer}
                    </p>
                  </div>
                </div>
                <div className="relative flex bg-white pt-5 px-4 pb-12 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden">
                  <div className="absolute  rounded-md p-3">
                    <MailOpenIcon
                      className="h-6 w-6 text-red-900"
                      aria-hidden="true"
                    />
                  </div>
                  <div>
                    <p className="ml-12 text-sm font-medium text-gray-500 truncate">
                      Total New to bank Customers
                    </p>
                    <p className="text-2xl ml-12 font-semibold text-red-900">
                      {summ.totalNewCustomerToBank}
                    </p>
                  </div>
                </div>
              </dl>
              <div className="">
                <div className="flex">
                  <div className=" relative rounded-md shadow-sm ">
                    <p className="text-sm leading-3 text-gray-500">From</p>
                    <div>
                      <DatePicker
                        onChange={dateValidation.fromHandler}
                        value={formValues.from}
                      />
                    </div>
                  </div>
                  <div className=" relative rounded-md shadow-sm ml-3">
                    <p className="text-sm leading-3 text-gray-500">To</p>
                    <div>
                      <DatePicker
                        onChange={dateValidation.toHandler}
                        value={formValues.to}
                      />
                    </div>
                  </div>

                  <div className="mt-5 ml-4 relative rounded-md shadow-sm">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <SearchIcon
                        className="h-5 w-5 text-gray-400"
                        aria-hidden="true"
                      />
                    </div>
                    <input
                      type="text"
                      name="user"
                      id="user"
                      onChange={(e) => searchCustomer(e.target.value)}
                      className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                      placeholder="Search"
                    />
                    <div className=" absolute inset-y-0 right-0 flex items-center pr-3">
                      <div className="tooltip">
                        <QuestionMarkCircleIcon className="w-4 mr-1.5 text-gray-400" />
                        <span className="tooltiptext">
                          {" "}
                          <p>Search by phone number, account number, surname, NIN and email address</p>
                        </span>
                      </div>
                    </div>
                  </div>
                    <div className="mt-5 relative rounded-md shadow-sm ml-3">
                      <select
                      id="currency"
                      name="currency"
                      onChange={(e) => setSort(e)}
                      placeholder="Sort by"
                      className="focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2 pr-7 border-gray-300 bg-transparent text-gray-500 sm:text-sm rounded-md"
                    >
                      <option value={"sort"}>Sort by</option>
                      <option value={"All"}>All</option>
                      <option value={"Started"}>Started</option>
                      <option value={"BvnVerified"}>BVN Verified</option>
                      <option value={"OtpSent"}>OTP Sent</option>
                      <option value={"OtpVerified"}>OTP Verified</option>
                      <option value={"OnboardingCompleted"}>
                        Onboarding Completed
                      </option>
                      <option value={"VerificationMailSent"}>
                        Verification Mail Sent
                      </option>
                      <option value={"MailVerified"}>Mail Verified</option>
                      <option value={"Completed"}>Completed</option>
                      <option value={"Device_OtpSent"}>Device OTP Sent</option>
                      <option value={"NotStarted"}>Not Started</option>
                      <option value={"UnVerified"}>Unverified</option>
                      <option value={"LoginCredentialsCreated"}>
                        Login Credentials Created
                      </option>
                    </select>
                  </div>
                  <div className="mt-5 ml-4">
                    <button
                      onClick={range}
                      className="hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-6 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
                    >
                      Search
                    </button>
                  </div>
                  <div className=" ml-4 justify-end">
                    <button
                      type="button"
                      onClick={exportCSV}
                      className="hover:text-white mt-5 active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-2 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
                    >
                      <DocumentDownloadIcon className="w-4 mr-1.5" />
                      Export CSV
                    </button>
                  </div>
                </div>
                <div className="flex mt-5"></div>
                {customer.length === 0 ? (
                  <div className=" mt-8">
                    {" "}
                    No data available for these dates to show.{" "}
                  </div>
                ) : (
                  <>
                    <div className="mt-8 flex flex-col">
                      <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                          <div className="relative ring-1 ring-black ring-opacity-5 md:rounded-lg ">
                            <table className="min-w-full table-fixed divide-y divide-gray-300">
                              <thead>
                                <tr>
                                  <th
                                    scope="col"
                                    className="min-w-[8rem] pl-4 py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900"
                                  >
                                    Username
                                  </th>
                                  <th
                                    scope="col"
                                    className="min-w-[10rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900"
                                  >
                                    Account Name
                                  </th>
                                  <th
                                    scope="col"
                                    className="min-w-[10rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900"
                                  >
                                    New to Bank
                                  </th>
                                  <th
                                    scope="col"
                                    className="min-w-[10rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900"
                                  >
                                    BVN
                                  </th>
                                  <th
                                    scope="col"
                                    className="min-w-[10rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900"
                                  >
                                    MIS Code
                                  </th>
                                  <th
                                    scope="col"
                                    className="min-w-[10rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900"
                                  >
                                    BVN Phone number
                                  </th>
                                  <th
                                    scope="col"
                                    className="min-w-[10rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900"
                                  >
                                    BVN Email address
                                  </th>
                                  <th
                                    scope="col"
                                    className="min-w-[10rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900"
                                  >
                                    Date Created
                                  </th>
                                  <th
                                    scope="col"
                                    className="min-w-[6rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900"
                                  >
                                    Time Created
                                  </th>
                                  <th
                                    scope="col"
                                    className="min-w-[10rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900"
                                  >
                                    Date Onboarded
                                  </th>
                                  <th
                                    scope="col"
                                    className="min-w-[10rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900"
                                  >
                                    Date Last Modified
                                  </th>
                                  <th
                                    scope="col"
                                    className="min-w-[6rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900"
                                  >
                                    Time Last Modified
                                  </th>
                                  <th
                                    scope="col"
                                    className="min-w-[10rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900"
                                  >
                                    Longitude
                                  </th>
                                  <th
                                    scope="col"
                                    className="min-w-[10rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900"
                                  >
                                    Latitude
                                  </th>
                                  <th
                                    scope="col"
                                    className="min-w-[8rem] pr-3 py-3.5 text-left text-sm italic font-normal text-gray-900"
                                  >
                                    Registration Status
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900"
                                  >
                                    Email address
                                  </th>
                                  <th
                                    scope="col"
                                    className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-900"
                                  >
                                    Date of Birth
                                  </th>
                                  <th
                                    scope="col"
                                    className="min-w-[10rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-900"
                                  >
                                    Residential Address
                                  </th>
                                  <th
                                    scope="col"
                                    className="min-w-[8rem] px-1 py-3.5 text-left text-sm italic font-normal text-gray-900"
                                  >
                                    State of Residence
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900"
                                  >
                                    LGA
                                  </th>
                                  <th
                                    scope="col"
                                    className="min-w-[8rem]  px-3 py-3.5 text-left text-sm italic font-normal text-gray-900"
                                  >
                                    Phone Number
                                  </th>
                                  <th
                                    scope="col"
                                    className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-900"
                                  >
                                    Account Locked
                                  </th>
                                  <th
                                    scope="col"
                                    className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-900"
                                  >
                                    Exceptional Limit
                                  </th>
                                  <th
                                    scope="col"
                                    className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-900"
                                  >
                                    Last Modified by
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900"
                                  >
                                    Action
                                  </th>
                                  {/* <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                              <span className="sr-only">Edit</span>
                            </th> */}
                                </tr>
                              </thead>
                              <tbody className="divide-y divide-gray-200 bg-white">
                                {customer.map((person, i) => (
                                  <tr key={i} className="bg-gray-50">
                                    <td className="whitespace-nowrap pl-4  py-4 pr-3 text-sm font-medium text-indigo-600">
                                      {person.userName == null
                                        ? "N/A"
                                        : person.userName}
                                    </td>
                                    <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">
                                      {person.surname}{" "}
                                      {pascalCASE(person.firstName)}
                                    </td>
                                    <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">
                                      {person.newToBank === false
                                        ? "No"
                                        : "Yes"}
                                    </td>
                                    <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">
                                      {person.bvn}
                                    </td>
                                    <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">
                                      {person.misCode}
                                    </td>
                                    <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">
                                      {person.bvnPhoneNumber}
                                    </td>
                                    <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">
                                      {person.bvnEmailAddress}
                                    </td>
                                    <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">
                                      {formatDateForDisplay(person.dateCreated)}
                                    </td>
                                    <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">
                                      {DisplayTime(person.dateCreated)}
                                    </td>
                                    <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">
                                      {formatDateForDisplay(
                                        person.dateVerified
                                      )}
                                    </td>
                                    <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">
                                      {formatDateForDisplay(
                                        person.dateModified
                                      )}
                                    </td>
                                    <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">
                                      {DisplayTime(person.dateModified)}
                                    </td>
                                    <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">
                                      {person.longitude}
                                    </td>
                                    <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">
                                      {person.latitude}
                                    </td>
                                    <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">
                                      {person.registrationStage == null
                                        ? "N/A"
                                        : person.registrationStage}
                                    </td>
                                    <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">
                                      {person.emailAddress == null
                                        ? "N/A"
                                        : person.emailAddress}
                                    </td>
                                    <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">
                                      {" "}
                                      {convert(person.dateOfBirth)}
                                    </td>
                                    <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">
                                      {person.residentialAddress == null
                                        ? "N/A"
                                        : person.residentialAddress}
                                    </td>
                                    <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">
                                      {person.state == null
                                        ? "N/A"
                                        : person.state}
                                    </td>
                                    <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">
                                      {person.lga == null ? "N/A" : person.lga}
                                    </td>
                                    <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">
                                      {person.phoneNumber == null
                                        ? "N/A"
                                        : person.phoneNumber}
                                    </td>
                                    <td>
                                      <span
                                        className={classNames(
                                          statusStyles[person.isLocked],
                                          "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium text-gray-900"
                                        )}
                                      >
                                        {person.isLocked === true
                                          ? "Yes"
                                          : "No"}
                                      </span>
                                    </td>
                                    <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">
                                      {person.hasExceptionalLimit === true
                                        ? "Yes"
                                        : "No"}
                                    </td>
                                    <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">
                                      {person.modifiedBy == null
                                        ? "N/A"
                                        : person.modifiedBy}
                                    </td>
                                    <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                      {person.userName == null ? (
                                        <ActionDropdown
                                          dropdownWidth="w-56"
                                          items={[
                                            { label: "View Customer", onClick: () => window.location.href = person.userId ? `/customer/view?userId=${person.userId}` : `/customer/view?id=${person.userName}` },
                                          ]}
                                        />
                                      ) : (
                                        <ActionDropdown
                                          dropdownWidth="w-56"
                                          items={[
                                            { label: "View Customer", onClick: () => window.location.href = person.userId ? `/customer/view?userId=${person.userId}` : `/customer/view?id=${person.userName}` },
                                            ...(securityFeature === "security" && sleepLoader.sleep === false && person.freezeTransactions === true
                                              ? [{ label: "Disable Sleep mode", onClick: () => sleepMode(person), className: "bg-red-100 text-red-700" }]
                                              : []),
                                            { label: "Review Documents", onClick: () => window.location.href = `/customer/document?id=${person.userName}` },
                                            ...(securityFeature === "security" && maskLoader.mask === false && person.stealthMode === "Active"
                                              ? [{ label: "Disable Mask mode", onClick: () => maskMode(person), className: "bg-red-100 text-red-700" }]
                                              : []),
                                            { label: "View Address", onClick: () => window.open(`${process.env.REACT_APP_MAP}${encodeURI(person.residentialAddress)}`) },
                                            ...(securityFeature === "security" && panicLoader.panic === false && person.panicModeEnabled === true
                                              ? [{ label: "Disable Panic mode", onClick: () => panicMode(person), className: "bg-red-100 text-red-700" }]
                                              : []),
                                            ...(!(person.customerStatus === "Active" && person.registrationStage === "Completed") && loading.loading === false
                                              ? [{ label: "Resend Mail", onClick: () => resendMail(person.userName) }]
                                              : []),
                                            ...(maskLoader.mask === false
                                              ? [{ label: "Reset User", onClick: () => resetUser(person) }]
                                              : []),
                                            { label: "Clear Cache", onClick: () => openClearCacheModal(person.userName) },
                                          ]}
                                        />
                                      )}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <Paginate
                      nextPage={nextPage}
                      pageIndex={pageIndex}
                      totalCount={pageNumber}
                      totalPages={totalPage}
                      prevPage={prevPage}
                      setPageIndex={setPageIndex}
                    />
                  </>
                )}
              </div>
            </div>
          </main>  
          <ClearCacheModal
            open={openModal}
            setOpen={setOpenModal}
            clearCache={clearCache}
            userName={selectedUserName}
          />

        </React.Fragment>
      </Layout>
    </>
  );
}